'use client';

import { CollectionRoomListGrid } from '@/modules/product/components/collection-room/CollectionRoomListGrid';

import { AlgoliaProvider } from '../AlgoliaSearch/AlgoliaProvider';

export const CollectionRoomContent = () => {
  return (
    <section>
      <h2 className="mb-6 px-4 text-xl font-bold lg:px-8 lg:text-[28px]">
        More ways to get this look
      </h2>

      <AlgoliaProvider>
        <CollectionRoomListGrid />
      </AlgoliaProvider>
    </section>
  );
};
